export type ArticleRenderData = {
  html: string;
  articleId: number;
  articleTitle: string;
};

let pendingArticleData: ArticleRenderData | null = null;
let articleRenderCallback: ((data: ArticleRenderData) => void) | null = null;

export function setArticleRenderCallback(
  callback: ((data: ArticleRenderData) => void) | null,
) {
  articleRenderCallback = callback;

  if (articleRenderCallback && pendingArticleData) {
    articleRenderCallback(pendingArticleData);
    pendingArticleData = null;
  }
}

// A pending article belongs to the connection that received it. A new game
// connection gets its current article from the server again, so anything
// still pending from an earlier page or round must not be shown instead.
export function clearPendingArticleRender() {
  pendingArticleData = null;
}

export const queueArticleRender = (data: ArticleRenderData) => {
  if (articleRenderCallback) {
    articleRenderCallback(data);
  } else {
    pendingArticleData = data;
  }
};
